import React from 'react'

export const CommonButton = ({startValue, endValue, displayName, handleSetTimeRange, handleReset}) => {

    const handleClick = () => startValue && endValue ? handleSetTimeRange(startValue, endValue) : handleReset()

    return (
        <button className="button-icontrigger caption noborder"
                type="button"
                onClick={handleClick}
        >
            {displayName}
        </button>
    )
}

